import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Menu, UserAvatar } from '@pocketlaw/tetris';
import { useAssigneesField } from '../useAssigneesField';
export function AssigneeDropdown() {
    const [inputValue, setInputValue] = useState('');
    const { addAssignee, removeAssignee, selectedAssignees, unselectedAssignees, searchResult, search } = useAssigneesField();
    const unSelected = inputValue ? searchResult : unselectedAssignees;
    const showAllUsersLabel = unselectedAssignees.length > 0 && !inputValue;
    const showSearchLabel = searchResult.length > 0 && inputValue;
    const handleSearch = (value) => {
        setInputValue(value);
        search(value);
    };
    return (<Fragment>
      <Menu.HeaderSearch value={inputValue} onChange={handleSearch} placeholder={t({
            message: 'Search users',
            comment: 'Assign users dropdown search placeholder',
        })}/>
      {selectedAssignees.length > 0 && (<Menu.Label>
          <Trans comment="Assign users dropdown selected users section title">Assigned</Trans>
        </Menu.Label>)}
      {selectedAssignees.map((assignee) => (<Menu.ItemCheckbox key={assignee.id} checked onChange={() => removeAssignee(assignee.id)}>
          <UserAvatar size="sm" title={assignee.name}/>
        </Menu.ItemCheckbox>))}

      {showAllUsersLabel && (<Menu.Label>
          <Trans comment="Assign users dropdown unselected users section title">All users</Trans>
        </Menu.Label>)}
      {showSearchLabel && (<Menu.Label>
          <Trans comment="Assign users dropdown unselected searched users section title">Filtered</Trans>
        </Menu.Label>)}
      {unSelected.map((assignee) => (<Menu.ItemCheckbox key={assignee.id} checked={false} onChange={() => addAssignee(assignee)}>
          <UserAvatar size="sm" title={assignee.name}/>
        </Menu.ItemCheckbox>))}
    </Fragment>);
}
